import React from 'react';
import { useIntl } from '@tink/core/src/components/providers/LanguageProvider/useIntl';
import { VerboseErrorScreen } from '../../../../../../../components/screens/VerboseErrorScreen/VerboseErrorScreen';
import { PageView } from '../../../../../../../models/analytics';
import { messages } from './messages';

export const HandoffPayError: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <VerboseErrorScreen
      title={formatMessage(messages.error)}
      viewEvent={PageView.HANDOFF_PAY_ERROR_SCREEN}
    />
  );
};
